import script from "./ModalSentMessageBack.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSentMessageBack.vue?vue&type=script&setup=true&lang=js"

import "./ModalSentMessageBack.vue?vue&type=style&index=0&id=5fd4daa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd4daa2"]])

export default __exports__